import { MenuPresets } from '@framework/form/inputs/rich-text/menu/MenuPresets.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { yup } from '@framework/validation/initYup.ts';
import { RichTextAdvancedInput } from '../../../../../inputs/rich-text-advanced/RichTextAdvancedInput.tsx';
import { RichTextAdvancedSchema } from '../../../../../inputs/rich-text-advanced/schema/RichTextAdvancedSchema.ts';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { WidgetType } from '../../../Widget.ts';
import { BaseLayoutColSpanInput } from '../../common/BaseLayoutColSpanInput.tsx';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps.ts';
import { CommonGraphicWidgetConfigSchema } from '../common/CommonGraphicWidgetConfigSchema.ts';
import { type IDividerWidget } from './IDividerWidget.ts';

export const DividerWidgetConfigSchema = CommonGraphicWidgetConfigSchema.shape({
  type: yup.string().exact(WidgetType.Divider).required(),
  title: RichTextAdvancedSchema.optional().label('Titolo'),
})
  .required()
  .noUnknown() satisfies yup.ObjectSchema<IDividerWidget>;

export interface IDividerWidgetConfigComponentProps
  extends IWidgetComponentProps<IDividerWidget> {}

export function DividerWidgetConfigComponent(
  props: IDividerWidgetConfigComponentProps,
) {
  const options = getWidgetProps(props);

  return (
    <div>
      <BaseLayoutColSpanInput isTableColumn={options.isTableColumn} />

      <FormItem name="title" label="Testo">
        <RichTextAdvancedInput
          name="title"
          menus={MenuPresets.Inline}
          rows={3}
        />
      </FormItem>
    </div>
  );
}
